import { List, Misc, ModalUtils, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";
import { AppService, DomainTypes, Types } from '../../../DomainTypes';
import InvestorReferralType from "../../../Models/Catalogue/Investments/InvestorReferralType";

@NeoModel
export default class InvestorReferralTypeVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        protected investmentApiClient = AppService.get(Types.Domain.ApiClients.CatalogueInvestment),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)) {

        super(taskRunner);
    }

    public investorReferralTypeList = new List(InvestorReferralType);
    public editingInvestorReferralType: InvestorReferralType | null = null;

    public async initialise() {
        const response = await this.taskRunner.waitFor(this.investmentApiClient.getInvestorReferralTypes());
        this.investorReferralTypeList.set(response.data);
    }

    public async deleteInvestorReferralType(investorReferralTypeId: InvestorReferralType) {
        if (await ModalUtils.showYesNo("Delete", "Are you sure you want to delete this item?") === Misc.ModalResult.Yes) {
            if (!(this.editingInvestorReferralType?.isNew))
            {
                this.investorReferralTypeList.remove(investorReferralTypeId);
                this.saveInvestorTypes(true);
            }
            else
            {
                this.investorReferralTypeList.remove(investorReferralTypeId);
            }
            this.notifications.addSuccess("Delete Successful", "Investor types were deleted successfully.", NotificationDuration.Standard);
        }
    }

    public editInvestorReferralTypes(item: InvestorReferralType) {
        this.editingInvestorReferralType = item;
    }

    public newInvestorReferralType() {
        this.editingInvestorReferralType = new InvestorReferralType;
    }

    public saveInvestorTypes(isDelete: boolean = false) {
        if (!isDelete) {
            if (this.editingInvestorReferralType!.isNew) {
                this.investorReferralTypeList.push(this.editingInvestorReferralType!);
            }
        }
        this.taskRunner.run(async () => {
            const response = await this.investmentApiClient.saveInvestorReferralTypes(this.investorReferralTypeList.toJSArray())
            this.investorReferralTypeList.update(response.data);
            this.dataCache.investorReferralTypes.expire();
            if (!isDelete) {
                this.notifications.addSuccess("Save Successful", "Investor referral types were saved successfully.", NotificationDuration.Standard);
            }
        });
    }
}